import styled from 'styled-components';

export const Section = styled.section`
  padding: 80px 24px;
  background: #010606;
  color: #fff;
`;

export const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

export const Heading = styled.h2`
  font-size: 2rem;
  text-align: center;
  margin-bottom: 16px;
  color: #f7f8fa;
`;

export const Subtext = styled.p`
  text-align: center;
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 48px;
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 32px 24px;
  align-items: center;
  justify-items: center;

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px 16px;
  }
`;

export const PartnerCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100px;
  padding: 20px 16px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: background 0.2s ease, border-color 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(1, 191, 113, 0.3);
  }
`;

export const Logo = styled.img`
  max-width: 100%;
  max-height: 48px;
  width: auto;
  height: auto;
  object-fit: contain;
  filter: brightness(0) invert(1);
  opacity: 0.9;

  &.color {
    filter: none;
    opacity: 1;
  }
`;

export const PartnerName = styled.span`
  margin-top: 10px;
  font-size: 0.9rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  line-height: 1.2;
`;
